$.extend(true, BT, {
	loadRecentViewedProductsSingle: function(wrap) {
    if(typeof wrap == 'undefined' || wrap.length == 0) {
      return;
    }
    var ins = this;
    var productId = wrap.attr('data-id');
    var limit = parseInt(wrap.attr('data-limit'));
    var idItems = this.getCookieItemsValue(true, this.options.recentView.cookieName);
    var index = idItems.indexOf(productId);
    if(index > -1) {
      idItems.splice(index, 1);
    }
    console.log(idItems);
    if(idItems.length > 0) {
      idItems.reverse();
      var ids = idItems.slice(0, limit);
      this.callAjax(theme.searchUrl, 'GET', {view:'recent_view_slider', q: BT.getQueryByIds(ids), type: 'product'}, null, function(html) {
        wrap.html(html);
        var list = wrap.find('.recent-view-list');
        if(list.length > 0) {
          if(list.hasClass('slick-initialized')) {
            list.slick('unslick');
          }
          if(list.find('.grid__item').length > 0) {
            ins.convertCurrencySilence(list.find('span.money'));
            ins.applyCustomColorSwatches(list);
            ins.initSlider(wrap, false, false);
            ins.popularAddedWishlistItems(wrap);
          }
        }
      });
    } else {
      wrap.html('<div class="alert alert-warning">' + theme.strings.recentViewEmpty + '</div>');
    }
  }
});

theme.recentlyViewed = {};
theme.RecentlyViewedSection = (function() {
  function RecentlyViewedSection(container) {
    var $container = this.$container = $(container);
		var recentWrap = $container.find('.recently-viewed-ele');
    if(recentWrap.length > 0) {
      if(!Shopify.designMode) {
        BT.initScrollingWindowTriggerOnce(recentWrap, 'recent_view_single', -170, function() {
          BT.loadRecentViewedProductsSingle(recentWrap);
        });  
      } else {
        BT.loadRecentViewedProductsSingle(recentWrap);
      }
    }
  }

  return RecentlyViewedSection;
})();

theme.sections.constructors['main-product-recently-viewed'] = theme.RecentlyViewedSection;